import { qpTourStyles, typeSomeText } from "./common";
import { originalTourSteps } from "./variants/original";
import { accessibilityTourSteps } from "./variants/accessibility";
import { teacherTourSteps } from "./variants/teacher";
import { aiFirstTourSteps } from "./variants/ai-first";
import { a11yTourSteps } from "./variants/a11y";
import { mobileTourSteps } from "./variants/mobile";

// To add new tours, import them here and add to the switch

export { qpTourStyles, typeSomeText };

export type TourVariant = "original" | "accessibility" | "teacher" | "ai-first" | "a11y" | "mobile";

// You can change this default to switch the tour for everyone,
// or use getTourSteps explicitly with a variant.
const DEFAULT_VARIANT: TourVariant = "ai-first";

export const getTourSteps = (hostId: string, variant: TourVariant = DEFAULT_VARIANT) => {
	switch (variant) {
		case "mobile":
			return mobileTourSteps(hostId);
		case "ai-first":
			return aiFirstTourSteps(hostId);
		case "a11y":
			return a11yTourSteps(hostId);
		case "accessibility":
			return accessibilityTourSteps(hostId);
		case "teacher":
			return teacherTourSteps(hostId);
		case "original":
		default:
			return originalTourSteps(hostId);
	}
};

// Default export for backward compatibility with existing consumers
export const tourSteps = (hostId: string) => getTourSteps(hostId);
